import axios from 'axios';
import {URL, URLPhp} from './url';

function sendMail(formData){
    return axios.post(URLPhp+"/mail2.php", formData, {
        headers:{
            "Content-Type":"multipart/form-data"
        }
    })
}

function getPvi(id){
    return axios.get(URLPhp+"/server.php?action=getAllOfPVI&id=" + id);
}

function pviExist(id){
    return axios.get(URLPhp+"/server.php?action=existPVI&id=" + id);
}

function getPviToModify(id){
    return axios.get(URLPhp+"/server.php?action=getPVI&id="+id);
}

function createPvi(id,formData){
    return axios.post(URLPhp+"/server.php?action=createPVI&id="+id, formData, {headers:{
        "Content-Type":"multipart/form-data"
    }});
}

function createDepannage(formData){
    return axios.post(URLPhp+"/server.php?action=createDepannage", formData, {headers:{
            "Content-Type":"multipart/form-data"
        }});
}

function getInterventionToCome(offset, limit, search = ''){
    let post = {
        role: window.localStorage.getItem('role'),
        codeInter: window.localStorage.getItem('codeInter'),
        search: search
    }
    return axios.post(URLPhp+"/server.php?action=getInterventionToCome&limit="+limit+"&offset="+offset, post);
}

function getInterventionPast(offset, limit, search = ''){
    let post = {
        role: window.localStorage.getItem('role'),
        codeInter: window.localStorage.getItem('codeInter'),
        search: search
    }
    return axios.post(URLPhp+"/server.php?action=getInterventionPast&limit="+limit+"&offset="+offset, post);
}

function insertCliSign(formDataCli, id){
    return axios.post(URLPhp+"/server.php?action=insertSignCli&id=" + id, formDataCli, {
        headers:{
            "Content-Type":"multipart/form-data"
        }
    })
}

function insertTechSign(formDataTech, id){
    return axios.post(URLPhp+"/server.php?action=insertSignTech&id=" + id, formDataTech, {
        headers:{
            "Content-Type":"multipart/form-data"
        }
    })
}

function insertImages(id, formData){
    return axios.post(URLPhp+"/imagesUpload.php?id="+id, formData,
    {
        headers:{
            "Content-Type":"multipart/form-data"
        }
    })
}

function deleteImages(id, photo){
    return axios.post(URLPhp+"/server.php?action=deleteImage&id="+id, photo,
    {
        headers:{
            "Content-Type":"multipart/form-data"
        }
    });
}

function uploadFile(document){
    return axios.post(URLPhp+"/uploadFile.php", document, {headers: {"content-type": "multipart/form-data;"}})
}
function uploadDocumentJoint(document){
    return axios.post(URLPhp+"/documentJointUpload.php", document, {headers: {"content-type": "multipart/form-data;"}})
}

function getDocumentsJoint(eventNumber){
    return axios.post(URLPhp+"/server.php?action=getDocumentsJoint&id="+eventNumber);
}

function getDescriptionInter(id){
    return axios.post(URLPhp+"/server.php?action=getDescriptionInter&id="+id);
}

function deleteDocumentsJoint(id){
    return axios.post(URLPhp+"/server.php?action=deleteDocumentJoint&id="+id)
}

function fetchUserById(id){
    return axios.get(URLPhp+"/server.php?action=getUserById&id="+id)
}

export default {
    sendMail,
    getPvi,
    pviExist,
    getPviToModify,
    createPvi,
    getInterventionToCome,
    insertCliSign,
    insertTechSign,
    insertImages,
    deleteImages,
    uploadFile,
    createDepannage,
    uploadDocumentJoint,
    getDocumentsJoint,
    getDescriptionInter,
    deleteDocumentsJoint,
    fetchUserById,
    getInterventionPast
}